/**
 * Translation / script options for api.thegita.org.in `chapterByLanguage/:code`.
 * If a code returns no data from the API, the reader will show an error — try another language.
 */
export const GITA_LANGUAGES = [
  { code: 'en', label: 'English', group: 'Common' },
  { code: 'hi', label: 'Hindi — हिन्दी', group: 'Indic' },
  { code: 'te', label: 'Telugu — తెలుగు', group: 'Indic' },
  { code: 'ta', label: 'Tamil — தமிழ்', group: 'Indic' },
  { code: 'kn', label: 'Kannada — ಕನ್ನಡ', group: 'Indic' },
  { code: 'ml', label: 'Malayalam — മലയാളം', group: 'Indic' },
  { code: 'bn', label: 'Bengali — বাংলা', group: 'Indic' },
  { code: 'gu', label: 'Gujarati — ગુજરાતી', group: 'Indic' },
  { code: 'mr', label: 'Marathi — मराठी', group: 'Indic' },
  { code: 'or', label: 'Odia — ଓଡ଼ିଆ', group: 'Indic' },
  { code: 'pa', label: 'Punjabi — ਪੰਜਾਬੀ', group: 'Indic' },
  { code: 'sa', label: 'Sanskrit — संस्कृतम्', group: 'Indic' },
];
